/**
 * DRF answers a rejected write with {field: ["reason"]}, which has no `message`
 * key — reading one gives every validation failure the same "Сервер хатоси".
 * Name the offending field instead, in the label the form used for it.
 *
 * labels maps a serializer field name to its on-screen label.
 */
export const readApiError = (error, labels = {}, fallback = "Сервер хатоси") => {
  const data = error.response?.data;
  if (!data) return fallback;
  if (typeof data === "string") return data;
  if (data.message) return data.message;
  if (data.detail) return data.detail;

  // Some endpoints nest the field map under `errors` instead of returning it flat.
  const body = data.errors && typeof data.errors === "object" ? data.errors : data;

  const [key, value] = Object.entries(body)[0] || [];
  if (!key) return fallback;

  const reason = Array.isArray(value) ? value[0] : value;
  if (key === "non_field_errors") return reason;

  return `${labels[key] || key}: ${reason}`;
};

/** Build the label map a form's field list implies. */
export const labelsFrom = (fields) =>
  fields.reduce((acc, f) => ({ ...acc, [f.key]: f.label }), {});
